import React from "react";
import HeroSection from "../components/HeroSection";
import { FirstBanner } from "../../LandingPage/FirstBanner";
import { Testimonials } from "../../LandingPage/Testimonials";
import SaddleSelectionControls from "../components/SaddleSelectionControls";

const Cactus = () => {
  return (
    <>
      <HeroSection />
      <SaddleSelectionControls isCactus={true} />
      <Testimonials />
      <FirstBanner type="CACTUS" />
    </>
  );
};

export default Cactus;
